/*@flow*/
import type { Element } from 'react';
import React from 'react';

export default ({
  type,
  message,
}: {
  type: string,
  message: ?React$Node,
}): Element<'div'> => (
  <div className={`alert alert-${type} mb-2 border-0`}>{message}</div>
);
